import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { GuardHelper } from './guard.helper';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate(): Promise<boolean> {
    const user = await GuardHelper.getCurrentUser();
    if (user) {
      this.router.navigate(['/admin/dashboard']);
      return false;
    }
    return true;
  }

 
}
